
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcSystemMenu as ObcSystemMenuElement} from '@oicl/openbridge-webcomponents/dist/components/system-menu/system-menu.js';
 
 
 

 
 export const ObcSystemMenu = createComponent({
   react: React,
   tagName: 'obc-system-menu',
   elementClass: ObcSystemMenuElement,
   events: {
     
     onWifiClick: 'wifi-click' as EventName<CustomEvent<unknown>>,
     onAudioClick: 'audio-click' as EventName<CustomEvent<unknown>>,
     onAudioVolumeChange: 'audio-volume-change' as EventName<CustomEvent<unknown>>,
     onMicrophoneClick: 'microphone-click' as EventName<CustomEvent<unknown>>,
     onBatteryUsageClick: 'battery-usage-click' as EventName<CustomEvent<unknown>>,
     onBatterySavingModeChange: 'battery-saving-mode-change' as EventName<CustomEvent<unknown>>,
     onBatteryModeChange: 'battery-mode-change' as EventName<CustomEvent<unknown>>,
     onWifiNetworkChange: 'wifi-network-change' as EventName<CustomEvent<unknown>>,
     onAudioOutputChange: 'audio-output-change' as EventName<CustomEvent<unknown>>,
     onMicrophoneInputChange: 'microphone-input-change' as EventName<CustomEvent<unknown>>,
     onSettingsClick: 'settings-click' as EventName<CustomEvent<unknown>>,
     onToSubMenuClick: 'to-sub-menu-click' as EventName<CustomEvent<unknown>>,
     onWifiOptionsClick: 'wifi-options-click' as EventName<CustomEvent<unknown>>,
     onWifiDisconnectClick: 'wifi-disconnect-click' as EventName<CustomEvent<unknown>>,
   }
  });
 
 